import { render } from "./FrequentlyAskedComponent.vue?vue&type=template&id=a10716d6"
import script from "./FrequentlyAskedComponent.vue?vue&type=script&lang=js"
export * from "./FrequentlyAskedComponent.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\hhsiao\\Downloads\\Mamba\\cloud-business\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__